import { createFileRoute } from '@tanstack/react-router';
import { getActivitiesOptions } from './../../../../features/insurance/activities/queryOptions';
import { validateSearch } from './../../../../utils/pagination';
import { ActivitiesTable } from './../../../../features/insurance/activities/table';

export const Route = createFileRoute(
  '/_authenticated/insurances/$guid/_layout/activities',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, deps: { page }, params: { guid } }) =>
    queryClient.ensureQueryData(getActivitiesOptions(guid, { page })),
  validateSearch: validateSearch,
});

function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="col-span-full flex items-center justify-between">
      <ActivitiesTable activities={data} />
    </div>
  );
}
